import React from 'react';

const TermsOfServiceContent = ({ onNavigateToContact }) => {
  return (
    <div style={{ marginTop: "1rem", lineHeight: "1.5", fontSize: "0.9rem" }}>
      <p><strong>Last Updated: June 6, 2025</strong></p>

      <h3>1. Acceptance of Terms</h3>
      <p>
        By accessing and using Stackform ("the Application"), you agree to be
          bound by these Terms of Service. If you do not agree to these terms,
          please do not use the Application.
      </p>

      <h3>2. Description of Service</h3>
      <p>
        Stackform is a multi-agent AI platform that lets you run coordinated
          teams of specialized AI agents across three modes — Ask (orchestrated
          research), Swarm (live multi-agent debate), and Workflows (custom
          visual pipelines). The Application is provided "as is" and "as
          available" without any warranties of any kind, either express or implied.
      </p>

      <h3>3. User Responsibilities</h3>
      <p>
        You are responsible for maintaining the confidentiality of your account
          and for all activities that occur under your account. You agree not
          to use the Application for any illegal or unauthorized purpose. You
          must not transmit any worms or viruses or any code of a destructive nature.
      </p>

      <h3>4. Intellectual Property</h3>
      <p>
        All content, features, and functionality of the Application (including
          but not limited to all information, software, text, displays, images,
          video, and audio, and the design, selection, and arrangement thereof)
          are owned by Stackform, its licensors, or other providers of such
          material and are protected by international copyright, trademark,
          patent, trade secret, and other intellectual property or proprietary rights laws.
      </p>

      <h3>5. Data and Privacy</h3>
      <p>
        We are committed to protecting your privacy. We will not share or sell
          your conversation data to any third party without approval. We may
          use your conversation data to improve the functionality and user
          experience of Stackform. We may also anonymize and aggregate data for
          research and to share insights with the community.
      </p>

      <h3>6. Limitation of Liability</h3>
      <p>
        In no event shall Stackform, its directors, employees, partners, agents,
          suppliers, or affiliates, be liable for any indirect, incidental,
          special, consequential, or punitive damages, including without
          limitation, loss of profits, data, use, goodwill, or other intangible
          losses, resulting from (i) your access to or use of or inability to
          access or use the Application; (ii) any conduct or content of any
          third party on the Application; (iii) any content obtained from the
          Application; and (iv) unauthorized access, use, or alteration of your
          transmissions or content, whether based on warranty, contract, tort
          (including negligence), or any other legal theory, whether or not we
          have been informed of the possibility of such damage.
      </p>

      <h3>7. Changes to Terms</h3>
      <p>
        We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. If a revision is material we will try to
          provide at least 30 days' notice prior to any new terms taking effect.
          What constitutes a material change will be determined at our sole
          discretion. Your continued use of the Application following any
          changes indicates your acceptance of the new terms.
      </p>

      <h3>8. Contact Us</h3>
      <p>
        If you have any questions about these Terms, please{" "}
        <button
          onClick={onNavigateToContact}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            color: "var(--link-color, #007bff)",
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "inherit",
            fontFamily: "inherit"
          }}
        >
          contact us
        </button>{" "}
        through the support channels provided in the Application.
      </p>
    </div>
  );
};

export default TermsOfServiceContent;
